import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InfiniteFetchList from './InfiniteFetchList';
import PerkCard from './PerkCard';

export default class PerkList extends Component {
  static propTypes = {
    perPage: PropTypes.number.isRequired,
    apiUrl: PropTypes.string.isRequired,
    noResultsMessage: PropTypes.string,
  }

  static defaultProps = {
    noResultsMessage: 'Oh no! Seems like there are no perks.',
  }

  renderItem = (item, key) => (
    <PerkCard key={key} {...item} />
  )

  render() {
    return (
      <InfiniteFetchList
        purgeDuplicateKey="url"
        apiUrl={this.props.apiUrl}
        perPage={this.props.perPage}
        itemRenderer={this.renderItem}
        noResultsMessage={this.props.noResultsMessage}
      />
    );
  }
}
